const {
  onVisitorChoicesConsentSetting,
} = require('../common/utils/consentEvents');
const { analyticsEventBus } = require('./events');
const { PAGE_ACTIONS } = require('./analyticsConst');
const { default: getFrontConfig } = require('../common/getFrontConfig');

const { currentLanguageCode, countryCode } = getFrontConfig();

let isInitialized = false;
const onReadyCallbacks = [];

const exportedToWindow = {
  onReady(callback) {
    if (isInitialized) {
      callback();
    } else {
      onReadyCallbacks.push(callback);
    }
  },
  analyticsEventBus,
};

window.bylAnalytics = exportedToWindow;

/**
 * Initialize the analytics module
 */
function init() {
  isInitialized = false;

  const bylCQuotient = require('./cquotient');
  bylCQuotient.init();
  window.bylCQuotient = bylCQuotient;
  require('./analytics');
  require('./tracking/gaInfo').beginTracking();
  require('./tracking/pageDesignerSections').beginTracking();
  require('./tracking/itemList').beginTracking();
  require('./tracking/searchData').beginTracking();
  require('./dwActiveData').init();
  require('./fitAnalytics').init();
  require('./globale').init();
  require('./ga4').init();
  require('./finally').addFinalHandlers();

  isInitialized = true;
  onVisitorChoicesConsentSetting(() => onReadyCallbacks.forEach((cb) => cb()));

  // Checking if info for Analytics needs to be sent
  const page = document.querySelector('.page');
  const isHome = page?.dataset.action === PAGE_ACTIONS.home;
  const isEventSent = localStorage.getItem('dispatcherAnalyticsEvent');
  if (!isEventSent && isHome) {
    analyticsEventBus.publish(
      analyticsEventBus.EVENTS.dispatcherMarketSelectionSubmitted,
      {
        url: `${window.location.host}/${countryCode.toLowerCase()}_${currentLanguageCode}`,
      }
    );
  }

  localStorage.setItem('dispatcherAnalyticsEvent', 'true');
}

module.exports = {
  init,
};
